export default __webpack_public_path__ + "static/media/glrc-course.let-them-eat-cake.8751d27e.png";